import * as React from 'react';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { AfterSchoolClubProgramme } from 'Src/models/clubProgramme';

type Props = {
  isOpen: boolean;
  selectedItems: AfterSchoolClubProgramme[];
  onDelete: () => void;
  onClose: () => void;
};

export const ClubProgrammeDeleteModal: React.FC<Props> = ({ isOpen, selectedItems, onDelete, onClose }) => {
  if (!isOpen) return null;

  const subject =
    selectedItems.length === 1
      ? `“${selectedItems[0].name || 'Untitled programme'}”`
      : `${selectedItems.length} programmes`;

  return (
    <SimpleModal
      isOpen={isOpen}
      title={selectedItems.length === 1 ? 'Delete programme?' : 'Delete programmes?'}
      customClass="cpProgrammeDialog cpProgrammeDeleteDialog"
      bodyClassName="cpProgrammeDialogBody"
      dialogStyle={{ maxWidth: 440 }}
      isBodyBold={false}
      onCloseClick={onClose}
      showFooter={false}
    >
      <div className="cpProgrammeDialogContent">
        <div className="cpProgrammeDialogLead isDanger">
          <span className="cpProgrammeDialogIcon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="M4.5 7h15" />
              <path d="M9 7V4.75h6V7" />
              <path d="m7 7 .7 12h8.6L17 7" />
              <path d="M10 10.5v5" />
              <path d="M14 10.5v5" />
            </svg>
          </span>
          <div>
            <strong>This action cannot be undone</strong>
            <p>Are you sure you want to permanently delete {subject}?</p>
          </div>
        </div>

        <div className="cpProgrammeDialogActions">
          <button type="button" className="cpProgrammeDialogButton isSecondary" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="cpProgrammeDialogButton isDanger" onClick={onDelete}>
            Delete {selectedItems.length === 1 ? 'programme' : 'programmes'}
          </button>
        </div>
      </div>
    </SimpleModal>
  );
};

ClubProgrammeDeleteModal.displayName = 'ClubProgrammeDeleteModal';
